import React, {useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {DeleteIconSvg, PlusIcon} from "../../assets/icons";
import {RedMessage, UploadImageButton} from "../../Components/StyledComponents";
import {setLoading} from "../../store/reducers/modalToggler";
import LoadingButton from "@mui/lab/LoadingButton";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {showToast} from "../../store/reducers/notificationSlice";
import {addArtImage} from "../addItems";
import {modifiedImagesList} from "../helpers";
import Skeleton from "@mui/joy/Skeleton";


function PanelImageViewer(
    {userImages, uploadBtn, images, getImagesData, inputHandler, imagesDispatcher, classNames, deleteImage, type, pageCount, setPageCount}
    ) {
    const inputRef = useRef();

    const {canvas} = useSelector((state) => state.canvas);
    const activeSheet = useSelector((state) => state.activeSheet).sheet;
    const {isLoggedIn} = useSelector((state) => state.loginSlice);
    const isAdmin = useSelector(state => state.loginSlice).isAdmin;

    const [btnLoading, setBtnLoading] = useState(false);
    const [noDataMsg, setNoDataMsg] = useState(false);

    const dispatch = useDispatch();

    const uploadFile = () => {
        if (!isLoggedIn) {
            dispatch(showToast({message: "Please login first", type: "warning"}));
            return;
        }
        inputRef.current.click();
    };


    const addImageToCanvas = (item, id) => {
        dispatch(setLoading(true))
        addArtImage(item, 100, 100, canvas, id, activeSheet, false).then(() => {
            dispatch(setLoading(false))
        })
    };

    const replaceBaseUrl = (originalUrl) => {
        const extractedBaseUrl = originalUrl.match(/(https?:\/\/[^\/]+\/)/)[0];
        return originalUrl.replace(extractedBaseUrl, `${process.env.REACT_APP_OnFlyResize}/fit-in/100x100/`);
    }

    const loadMoreImages = () => {
        if (isLoggedIn) {
            setBtnLoading(true)
            const newPage = pageCount + 1;
            getImagesData(type, newPage).then(async (res) => {
                const data = await modifiedImagesList(res, activeSheet);
                imagesDispatcher(data)
                setBtnLoading(false)
                setPageCount(newPage)

            })
                .catch(err => {
                    setNoDataMsg(true)
                    setTimeout(() => {
                        setNoDataMsg(false);
                    }, 4000);
                    setBtnLoading(false)
                });
        }
    }

    return (
        <div className="gallery-wrapper">
            {(isAdmin || userImages) &&
                <>
                    <UploadImageButton onClick={uploadFile}>
                        <PlusIcon/>
                        <span>{uploadBtn}</span>
                    </UploadImageButton>

                    <input
                        ref={inputRef}
                        onChange={inputHandler}
                        onClick={(e) => (e.target.value = null)}
                        multiple="multiple"
                        className="d-none"
                        type="file"
                        name="file"
                        accept="*"
                    />
                </>
            }
            <div className="images-grid-image-panel gallery-content gnr-m-0 image-grid">
                {
                    images && images.map((item, key) => (
                        <div
                            className={`image-grid__images ${classNames && classNames} ${item.loading ? 'loading-image' : ''}`}
                            key={key}>

                            {item.loading ?
                                (
                                    <div className="progress progress-width">
                                        <div
                                            className="progress-bar"
                                            role="progressbar"
                                            style={{width: `${item.progress}%`}}
                                            aria-valuenow="25"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                        >
                                            {item.progress - 1}
                                            %
                                        </div>
                                    </div>
                                ) :
                                <>
                                    {
                                        (item.imageUrl || item.compressedUrl) ?
                                            <LazyLoadImage
                                                style={{objectFit: 'contain', cursor: 'pointer'}}
                                                onClick={() => {
                                                    addImageToCanvas(item.compressedUrl ? `${process.env.REACT_APP_cdnURL}/` + item.compressedUrl : item.imageUrl, item.id)
                                                }}
                                                src={replaceBaseUrl(item.imageUrl)}
                                                height={90}
                                                width={90}
                                                alt="imageOb"
                                            />
                                            :
                                            <Skeleton variant="rectangular" width={90} height={90} />
                                    }
                                    {(isAdmin || userImages) &&
                                        <span className="delete-image position-absolute" onClick={() => deleteImage(item.id)}>
                                            <DeleteIconSvg fill="#fff"/>
                                        </span>
                                    }
                                </>
                            }
                        </div>
                    ))
                }
            </div>
            {noDataMsg && <RedMessage className="">No more data</RedMessage>}
            {images && images.length > 0 &&
            <LoadingButton sx={{mt: 3}}
                           onClick={loadMoreImages}
                           loading={btnLoading}
                           loadingPosition="end"
                           endIcon={<PublishedWithChangesIcon/>}
                           variant="contained"
            >
                <span>Load more</span>
            </LoadingButton>
            }
        </div>
    );
}

export default PanelImageViewer;
